/**
 * @desc getCabinByDono
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.CabinMasterResponseDto>;
export function request(body: defs.tms.CabinMasterRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMaster/getCabinByDono`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
